.stack {
  position: fixed;
  top: 70px;
  left: 50%;
  z-index: var(--cl-z-tooltip);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transform: translateX(-50%);
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 280px;
  max-width: min(560px, calc(100vw - 32px));
  padding: 10px 12px 10px 16px;
  border-radius: var(--cl-radius-nd-small);
  color: var(--ui-toast-text);
  font-size: var(--cl-fs-base);
  box-shadow: var(--cl-menu-shadow);
  pointer-events: auto;
}

.success {
  background: var(--cl-toast-success-bg);
}

.error {
  background: var(--cl-toast-error-bg);
}

.info {
  background: var(--cl-toast-info-bg);
}

.message {
  flex: 1;
  min-width: 0;
}

.close {
  display: inline-flex;
  padding: 2px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  opacity: 0.85;
}

.close:hover {
  opacity: 1;
}
